import { createElement, useRef, useMemo } from 'react'
import { Form } from 'antd'
import clsx from 'clsx'
import { Input, Button } from 'src/component'
import {
  createDenserPeriodStructure,
  I18NS
} from 'src/utils'
import { useDenserPeriodUtils } from './denserPeriod.utils'
import s from './denserPeriod.module.scss'

export function DenserPeriod({ requestData, isApp }) {

  const formRef = useRef()

  const [ pw ] = useMemo(() => [ createDenserPeriodStructure() ], [])

  const { finish } = useDenserPeriodUtils({ formRef })

  return (
    <div
      className={`${s.root} forgetRoot`}
      style={{ display: isApp ? 'flex' : '', flexDirection: isApp ? 'column' : '' }}
    >
      <div className={`${s.back} forgetBack b-fx`}>
        {I18NS.PERIODICALUPDATEPASSWORD_WORD}
      </div>
      <Form
        name='basic1'
        ref={formRef}
        className={clsx(`${s.form} forgetForm-1 b-fx b-fx-col b-j-c`)}
        style={{ justifyContent: isApp ? 'space-evenly' : '' }}
        labelCol={{ span: 3 }}
        autoComplete='off'
        onFinish={finish}
      >
        {pw.map(t => createElement(Input, t))}
        <Button className='forgetNext' onClick={finish}>
          {I18NS.FINISH_WORD}
        </Button>
      </Form>
    </div>
  )
}